import { ApiBase, ApiResponse } from '../api-base';
import { inject } from 'aurelia';
import { IHttpClient } from '@aurelia/fetch-client';
import { ScheduleRowEntity } from './schedule-row-entity';

@inject(IHttpClient)
export class ScheduleRowApi extends ApiBase {

    constructor(http: IHttpClient) {
        super(http);
    }

    public async add(eventId: string, scheduleId: string, entity: ScheduleRowEntity): Promise<ScheduleRowEntity> {
        const dto = entity.toDto();
        const response = await this.post(this._baseUrl(eventId, scheduleId), dto);
        return ScheduleRowEntity.fromDto(response.content);
    }

    public async update(eventId: string, scheduleId: string, id: string, entity: ScheduleRowEntity): Promise<ScheduleRowEntity> {
        const dto = entity.toDto();
        const response = await this.patch(this._baseUrl(eventId, scheduleId) + '/' + id, dto);
        return ScheduleRowEntity.fromDto(response.content);
    }

    public async listByScheduleId(eventId: string, scheduleId: string): Promise<ScheduleRowEntity[]> {
        const response = await this.get(this._baseUrl(eventId, scheduleId));
        return ScheduleRowEntity.fromDtoArray(response.content);
    }
    public async getById(eventId: string, scheduleId: string, id: string): Promise<ScheduleRowEntity> {
        const response = await this.get(this._baseUrl(eventId, scheduleId) + '/' + id);
        return ScheduleRowEntity.fromDto(response.content);
    }

    public async deleteById(eventId: string, scheduleId: string, id: string): Promise<ApiResponse> {
        const response = await this.delete(this._baseUrl(eventId, scheduleId) + '/' + id);
        return response.content;
    }
    public async deleteByScheduleId(eventId: string, scheduleId: string): Promise<ApiResponse> {
        const response = await super.delete(this._baseUrl(eventId, scheduleId));
        return response.content;
    }
    private _baseUrl(eventId: string, scheduleId: string): string {
        return `api/events/${eventId}/schedules/${scheduleId}/rows`;
    }
}
